import { common, leaseCompanyMst } from '@libs/domain';
import type { RequestType } from '@libs/templates/mst';
import { MstRegistrationTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import {
  CheckboxField,
  TextNumberLabelField,
  TextStringField,
  labelName,
  useItemNames,
  withRerender,
} from '@ps-smart-cp/ppfw-client';
import { useLeaseCompanyItems } from './hooks';
import { leaseCompanyMstRegistrationFieldConfig } from './item-config';
import { LeaseCompanyMstRegistration } from './models';
import { fetchMst, register, update } from './repositories';

function PageComponent({ type, ...restProps }: PageProps & Pick<RequestType, 'type'>) {
  const getCommonLabelName = useItemNames(common.labelNames);
  const getLabelName = useItemNames(labelName);
  const { code } = useLeaseCompanyItems();

  const requestType =
    type === 'new'
      ? { type, registrationFunction: register }
      : { type, updateFunction: update, fetchFunction: fetchMst };

  return (
    <MstRegistrationTmpl
      mstName={leaseCompanyMst.names.laCompany}
      initMst={LeaseCompanyMstRegistration.init}
      items={{ ...leaseCompanyMstRegistrationFieldConfig, code }}
      {...requestType}
      {...restProps}
    >
      {(leaseCompanyMst, setLeaseCompanyMst, errorFields) => (
        <>
          <TextStringField
            items={leaseCompanyMstRegistrationFieldConfig}
            obj={leaseCompanyMst}
            setObj={setLeaseCompanyMst}
            prop="phoneNo"
            errorFields={errorFields}
          />
          <TextNumberLabelField
            items={leaseCompanyMstRegistrationFieldConfig}
            obj={leaseCompanyMst}
            setObj={setLeaseCompanyMst}
            prop="paymentDay"
            postLabel={getLabelName('day')}
            errorFields={errorFields}
          />
          <CheckboxField
            items={leaseCompanyMstRegistrationFieldConfig}
            obj={leaseCompanyMst}
            setObj={setLeaseCompanyMst}
            prop="eligibleBillingProvider"
            labelName={getCommonLabelName('eligibleBillingProvider')}
            errorFields={errorFields}
          />
        </>
      )}
    </MstRegistrationTmpl>
  );
}

export const Registration = withRerender(PageComponent, 'Registration');
